import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-form-order',
  templateUrl: './product.detail.component.html',
  styleUrls: ['./product.detail.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailComponent implements OnInit {
  product: any;

  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<ProductDetailComponent>) {

    this.product = data.product;



  }

  ngOnInit() {

  }


}
